<template>
  <v-container>
    <v-progress-linear
      :color="passwordValidation.color"
      height="10"
      :value="passwordValidation.precent"
      striped
    ></v-progress-linear>

    <v-list dense>
      <v-list-item-group>
        <v-list-item
          v-for="(item, i) in rules"
          :key="i"
        >
          <v-list-item-icon>
            <v-icon v-text="item.icon" :color="item.color"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="item.text"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-container>
</template>

<script>
export default {
  props: {
    Password: {
      type: String,
      required: true
    },
    PasswordConfirm: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      passwordValidation: {
        precent: 0,
        color: "light-blue",
        valid: false
      },
      rules: {
        match: {text: 'passwords match', color: 'red', icon: 'mdi-close-circle-outline', passed: false },
        lenght: {text: 'at least 8 characters', color: 'red', icon: 'mdi-close-circle-outline', passed: false },
        number: {text: 'contains number', color: 'red',icon: 'mdi-close-circle-outline', passed: false },
        lower: {text: 'contains lowercase letter', color: 'red',icon: 'mdi-close-circle-outline', passed: false },
        upper: {text: 'contains uppercase letter', color: 'red',icon: 'mdi-close-circle-outline', passed: false }
      }
    };
  },
  watch: {
    Password: function (val) {
      if (/\d/.test(val)){
        this.rules.number.passed = true
      } else {
        this.rules.number.passed = false
      }

      if (val.toString().length>=8){
        this.rules.lenght.passed = true
      } else {
        this.rules.lenght.passed = false
      }

      if (/[a-z]/.test(val)){
        this.rules.lower.passed = true
      } else {
        this.rules.lower.passed = false
      }

      if (/[A-Z]/.test(val)){
        this.rules.upper.passed = true
      } else {
        this.rules.upper.passed = false
      }

      if (this.Password == this.PasswordConfirm){
        this.rules.match.passed = true
      } else {
        this.rules.match.passed = false
      }
      this.checkPasswordMatch()
      this.updatePasswordValidation()
    },
    PasswordConfirm: function () {
      this.checkPasswordMatch()
      this.updatePasswordValidation()
    }
  },
  methods: {
    checkPasswordMatch(){
      if (this.Password == this.PasswordConfirm && this.Password.toString().length>0 && this.PasswordConfirm.toString().length>0){
        this.rules.match.passed = true
      } else {
        this.rules.match.passed = false
      }
    },
    updatePasswordValidation(){
      let precent = 0
      for (const property in this.rules) {
        if (this.rules[property].passed){
          precent += 20
          this.rules[property].color = "green"
          this.rules[property].icon = "mdi-checkbox-marked-circle-outline"
        } else {
          this.rules[property].color = "red"
          this.rules[property].icon = "mdi-close-circle-outline"
        }
      }

      this.passwordValidation.precent = precent

      if(this.passwordValidation.precent === 100){
        this.passwordValidation.valid = true
      } else {
        this.passwordValidation.valid = false
      }
      this.$emit('passwordValidation', this.passwordValidation)
    },
  },
};
</script>
